@use '~/theme/theme' as *;

.container {
  background-color: color(violet-600);
}
